import { render, staticRenderFns } from "./VehicleTradeDetail.vue?vue&type=template&id=56d7e85c&scoped=true"
import script from "./VehicleTradeDetail.vue?vue&type=script&lang=js"
export * from "./VehicleTradeDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleTradeDetail.vue?vue&type=style&index=0&id=56d7e85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7e85c",
  null
  
)

export default component.exports